document.addEventListener('DOMContentLoaded', function () {
  const PDF_DOWNLOAD_URL = "https://cdn.shopify.com/s/files/1/0636/6242/4250/files/667c069a60f87bc2d2985d85_ProductMenu_vertical_June2024_Update_JA_v4.pdf?v=1719791775"
  const PDF_FILE_NAME = "ProductMenu_2024.pdf"

  const downloadButton = document.getElementById("product-menu__download-btn")

  downloadButton.addEventListener("click", function () {
    this.classList.add("btn--loading")

    fetch(PDF_DOWNLOAD_URL)
      .then(response => response.blob())
      .then(blob => {
        // Create a link element, set its attributes, and trigger the download
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = PDF_FILE_NAME

        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      })
      .catch(error => console.error(`Error downloading PDF: ${error}`))
      .finally(() => this.classList.remove("btn--loading"))
  })
})